import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/RadioGroup/RadioGroup.docs.json';
import { RadioGroup, Radio, Box } from '@primer/components';
import { CheckIcon, XIcon, AlertIcon } from '@primer/octicons-react';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <DeprecationBanner replacementUrl={'/components/radio-group/react/latest'} mdxType="DeprecationBanner" />
    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="grid" sx={{gap: 3}}>
  <RadioGroup name="choiceGroup">
    <RadioGroup.Label>Choices</RadioGroup.Label>
    <FormControl>
      <Radio value="one" />
      <FormControl.Label>Choice one</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio value="two" />
      <FormControl.Label>Choice two</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio value="three" />
      <FormControl.Label>Choice three</FormControl.Label>
    </FormControl>
  </RadioGroup>
</Box>
`}</code></pre>
    <h3>{`Using onChange handlers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const WithOnChangeHandlers = () => {
  const [selectedRadioValue, setSelectedCheckboxValues] = React.useState('two')
  const [selectedRadioId, setSelectedRadioId] = React.useState()

  const handleRadioGroupChange = (selectedValue, e) => {
    setSelectedCheckboxValues(selectedValue)
    setSelectedRadioId(e.currentTarget.id)
  }

  const handleChoiceOneChange = e => {
    alert('Choice one has its own handler')
  }

  return (
    <Box display="grid" sx={{gap: 1}}>
      <RadioGroup name="choiceGroup" onChange={handleRadioGroupChange}>
        <RadioGroup.Label>Choices</RadioGroup.Label>
        <FormControl>
          <Radio value="one" onChange={handleChoiceOneChange} />
          <FormControl.Label>Choice one</FormControl.Label>
        </FormControl>
        <FormControl>
          <Radio value="two" defaultChecked />
          <FormControl.Label>Choice two</FormControl.Label>
        </FormControl>
        <FormControl>
          <Radio value="three" />
          <FormControl.Label>Choice three</FormControl.Label>
        </FormControl>
      </RadioGroup>

      {selectedRadioValue && <div>The selected radio value is {selectedRadioValue}</div>}
      {selectedRadioId && <div>The last selected radio ID is {selectedRadioId}</div>}
    </Box>
  )
}

render(<WithOnChangeHandlers />)
`}</code></pre>
    <h3>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RadioGroup disabled name="choiceGroup">
  <RadioGroup.Label>Choices</RadioGroup.Label>
  <FormControl>
    <Radio value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</RadioGroup>
`}</code></pre>
    <h3>{`Required`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RadioGroup required name="choiceGroup">
  <RadioGroup.Label>Choices</RadioGroup.Label>
  <FormControl>
    <Radio value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</RadioGroup>
`}</code></pre>
    <h3>{`With validation`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RadioGroup name="choiceGroup">
  <RadioGroup.Label>Choices</RadioGroup.Label>
  <FormControl>
    <Radio value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
  <RadioGroup.Validation variant="error">Your choices are wrong</RadioGroup.Validation>
</RadioGroup>
`}</code></pre>
    <h3>{`With caption`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RadioGroup name="choiceGroup">
  <RadioGroup.Label>Choices</RadioGroup.Label>
  <RadioGroup.Caption>You can pick any of these choices</RadioGroup.Caption>
  <FormControl>
    <Radio value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</RadioGroup>
`}</code></pre>
    <h3>{`A visually hidden label`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RadioGroup name="choiceGroup">
  <RadioGroup.Label visuallyHidden>Choices</RadioGroup.Label>
  <FormControl>
    <Radio value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</RadioGroup>
`}</code></pre>
    <h3>{`With an external label`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Box
    id="choiceHeading"
    borderBottomWidth="1px"
    borderBottomStyle="solid"
    borderBottomColor="border.default"
    pb={2}
    mb={3}
    fontSize={3}
  >
    Choices
  </Box>
  <RadioGroup aria-labelledby="choiceHeading" name="choiceGroup">
    <FormControl>
      <Radio value="one" />
      <FormControl.Label>Choice one</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio value="two" />
      <FormControl.Label>Choice two</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio value="three" />
      <FormControl.Label>Choice three</FormControl.Label>
    </FormControl>
  </RadioGroup>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      